import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import axios from 'axios';
import './Projection.css'

import { Api } from '../../../services/api';
import ProjectionSettingViewModal from './projection-modal/projection-setting-view-model';
import ProjectionAddModel from './projection-modal/projection-add';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { FaFileExcel, FaSave } from 'react-icons/fa';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

const Projection = () => {

    const [projection, setProjection] = useState([]);
    const [ColumnName, setColumnName] = useState([]);
    const [ColumnNameKey, setColumnNameKey] = useState([]);
    const [ColumnReComplated, setColumnReComplated] = useState({});


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isProjectionSetting, setIsProjectionSetting] = useState(false);


    const [isLoading, setIsLoading] = useState(true); // Add loading state
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);

    const [selectOnStartDate, setSelectOnStartDate] = useState('2023-01-01')
    const [selectOnEndDate, setSelectOnEndDate] = useState('2025-12-31')


    useEffect(() => {
        console.log('Fetching projects...');
        getProjection();

    }, []);




    const getProjection = async () => {
        setIsLoading(true);
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'get-income-statement', { headers })
            .then((response) => {
                ;
                setProjection(response.data.result);
                setColumnNameKey(response.data.ColumnValue)
                setColumnName(response.data.ColumnName)
                setColumnReComplated(response.data.ColumnReComplated)

                setSelectOnEndDate(response.data.endDate)
                setSelectOnStartDate(response.data.startDate)


                setIsLoading(false);
            })
            .catch((error) => {

                setIsLoading(false);
            });
    }



    const rowClass = (data) => {

        return {
            'selected-row': selectedProduct && selectedProduct['INCOME STATEMENT'] === data['INCOME STATEMENT'],
            'yellow-200': data['INCOME STATEMENT'] == "Sub Total",
            'font-bold': data['INCOME STATEMENT'] == 'Cash - end',

        };
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '' || rowData === 0 || rowData === '0' || rowData === null) {
            return <div style={{ height: '36px', paddingTop: "8px" }}></div>;
        }
        let numberValue = Number(rowData);
        if (isNaN(numberValue)) {
            return <div style={{ height: '36px', paddingTop: "8px" }}></div>;
        }

        const isNegative = rowData < 0;

        return <div style={{
            color: isNegative ? "red" : "black",
            height: '36px', paddingTop: "8px",
        }}>

            {formatCurrency(rowData)}

        </div>
    };

    const formatCurrency = (value) => {
        if (value == null) {
            return ''
        }
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const formatAsPercentageY = (val) => {
        let numberValue = parseFloat(val);

        if (numberValue === 0) {
            return '';
        }

        return (
            <div style={{ color: numberValue < 0 ? 'red' : 'black', height: '36px', paddingTop: '8px', }}>
                {numberValue.toFixed(2)}
            </div>
        );
    };

    const formatAsPercentageP = (val) => {
        let numberValue = parseFloat(val);

        if (numberValue === 0) {
            return '';
        }

        return (
            <div style={{ color: numberValue < 0 ? 'red' : 'black', height: '36px', paddingTop: '8px', }}>
                {numberValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
            </div>
        );
    };


    const renderDecimalCell = (rowData, column) => {
        const value = rowData[column.field];
        const tooltipId = `tooltip-${(rowData.id || Math.random().toString(36).substr(2, 9))}`; // Unique ID for tooltip

        // Handle zero values
        if (value === 0 || value === '0') {
            return <div style={{ height: '36px', paddingTop: "8px" }}></div>;
        }        

        // Add specific handling for % of Sales columns
        if (column.field.includes("% of Sales")) {
            if (typeof value === 'string' && value.includes('%')) {
                return <div style={{ height: '36px', paddingTop: "8px", textAlign: 'center' }}>{value}</div>;
            }
            if (typeof value === 'number') {
                return <div style={{ height: '36px', paddingTop: "8px", textAlign: 'center' }}>
                    {value.toFixed(2)}%
                </div>;
            }
            return <div style={{ height: '36px', paddingTop: "8px" }}></div>;
        }

        if (value === 'Gross Profit 8') {
            return <span className="flex justify-between" style={{ fontWeight: "bold", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                Gross Profit
                <BsFillInfoCircleFill size={15} id={tooltipId} className='text-gray-500 hover:text-gray-900' />
                <Tooltip
                    target={`#${tooltipId}`}
                    content={rowData['tooltipTitle']} // Assuming 'tooltipTitle' contains the tooltip text
                    position="top"
                    className="custom-tooltip"
                />
            </span>
        }

        //* ----------New Code by Suraj---------------------------
        if (rowData['INCOME STATEMENT'] === 'Doomsday Ratio') {
            if (value != 'Doomsday Ratio') {
                return formatAsPercentageY(value);
            }
        }

        if (rowData['INCOME STATEMENT'] === 'Current Ratio') {
            if (value != 'Current Ratio') {
                return formatAsPercentageY(value);
            }
        }

        if (rowData['INCOME STATEMENT'] === 'Debt to Equity') {
            if (value != 'Debt to Equity') {
                return formatAsPercentageY(value);
            }
        }

        if (rowData['INCOME STATEMENT'] === 'Gross Profit') {
            if (value != 'Gross Profit') {
                return formatAsPercentageP(value);
            }
        }
        //! -------------------------------------




        if (rowData['INCOME STATEMENT'] == '') {
            if (column.field.includes("% of Sales")) {
                return ''
            }
            // console.log('value---->', rowData)
        }




        if (column.field === ColumnNameKey[0]) {
            if (value == 'Total Accounts Receievable' || value == 'Total Other Current Assets' || value == 'Materials for Future Jobs' || value == 'Due from/(to) Shareholder' || value == 'WIP-Costs in Excess of Billings' || value == 'Total Fixed Assets' || value == 'Total Other Assets' || value == 'Total Current Liabilities' || value == 'Total Long Term Liabilities' || value == 'Total Equity' || value == 'Working Capital' || value == 'Current Ratio' || value == 'Doomsday Ratio' || value == 'Debt to Equity' || value == 'Sales per FTE Top 25% $143,552' || value == 'Sales per Man. Staff Top 25% $228,244' || value == 'Sales per PM Top 25% $425,533') {

                return (
                    <span className="flex justify-between" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '36px', }}>
                        {value}
                        {/* <BsFillInfoCircleFill size={15} className='text-gray-500 hover:text-gray-900' title={rowData['tooltipTitle']} /> */}
                        <BsFillInfoCircleFill id={tooltipId} className='text-gray-500 hover:text-gray-900' />
                        <Tooltip
                            target={`#${tooltipId}`}
                            content={rowData['tooltipTitle']} // Assuming 'tooltipTitle' contains the tooltip text
                            position="top"
                            className="custom-tooltip"
                        />
                    </span>
                )
            }
        }


        const isLastThreeRows = projection.length - projection.indexOf(rowData) <= 3;

        if (isLastThreeRows) {
            if (value === 0) {
                return ''
            }
            return value;
        }


        if (value === 'Cash-end (previous month)') {
            return <span style={{ fontWeight: "bold", textAlign:'left'}} title={rowData['tooltipTitle']}>{value}</span>
        }

        if (value === 'Total' || value === 'Sub total' || value === 'COGS' || value === 'Gross Profit') {
            return <span className="flex justify-between" style={{ fontWeight: "bold", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                {value}
                {/* <BsFillInfoCircleFill size={15} title={rowData['tooltipTitle']} className='text-gray-500 hover:text-gray-900' /> */}
                <BsFillInfoCircleFill id={tooltipId} className='text-gray-500 hover:text-gray-900' />
                <Tooltip
                    target={`#${tooltipId}`}
                    content={rowData['tooltipTitle']} // Assuming 'tooltipTitle' contains the tooltip text
                    position="top"
                    className="custom-tooltip"
                />
            </span>
        }

        if (rowData['INCOME STATEMENT'] === 'Total' || rowData['INCOME STATEMENT'] === 'Sub total' || rowData['INCOME STATEMENT'] === 'Cash-end (previous month)') {
            return <div style={{ fontWeight: "bold", padding: '0' }}>{priceBodyTemplatee(value)}</div>;
        }


        if (value === 'Cash - end') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Cash - end') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (rowData['INCOME STATEMENT'] === 'COGS') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (value === 'Net Profit') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Net Profit') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        if (value === 'Total Expenses') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Total Expenses') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        // ---------------------------------------


        if (rowData['INCOME STATEMENT'] === 'Gross Profit 8') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        if (value === 'Expenses') {
            return <span style={{ fontWeight: "bold", padding: '5px' }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Expenses') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (value === 'Projections And Assumptions') {
            return <span style={{ fontWeight: "bold", padding: '5px' }}>{value}</span>
        }
        
        if (value === 'NAHB Ratios') {
            return <span style={{ fontWeight: "bold", padding: '5px' }}>{value}</span>
        }        

        if (rowData['INCOME STATEMENT'] === 'Projections And Assumptions') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (value === 'Balance Sheet') {
            return <span style={{ fontWeight: "bold", padding: '5px' }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Balance Sheet') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        if (rowData['INCOME STATEMENT'] === 'Gross Profit') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        // ---------------------------------------
        if (value == "493304") {
            return priceBodyTemplatee(value);
        }
        const currentAssetsString = 'Current assets includes: Cash + Receivables + Other current assets LESS shareholder loan and due to related parties';
        const modifiedString = 'Current assets includes: Cash +R...';

        if (typeof value === 'string' && value === currentAssetsString) {
            // Display modified text
            const tooltip = 'Current assets includes: Cash + Receivables + Other current assets LESS shareholder loan and due to related parties';
            return (
                <span title={tooltip}>
                    {modifiedString}
                </span>
            );
        }
        if (typeof value === 'number' && value % 1 !== 0) {
            if (typeof value === 'string' && value.endsWith('%')) {
                return value;

            }
            if (value < 0) {
                <span style={{ color: "red" }}>
                    {priceBodyTemplatee(rowData)}
                </span>
            }

            return priceBodyTemplatee(value);
        }
        if (value === 0) {
            return ''
        }
        if (rowData['INCOME STATEMENT'] === 'Marketing & Sales' || rowData['INCOME STATEMENT'] === 'Admin wages' || rowData['INCOME STATEMENT'] === 'Facilities' || rowData['INCOME STATEMENT'] === 'Office' || rowData['INCOME STATEMENT'] === 'General & Admin' || rowData['INCOME STATEMENT'] === 'Total Accounts Receievable' || rowData['INCOME STATEMENT'] === 'JV Inc (exp)' || rowData['INCOME STATEMENT'] === 'Total Other Current Assets' || rowData['INCOME STATEMENT'] === 'Materials for Future Jobs' || rowData['INCOME STATEMENT'] === 'Due from/(to) Shareholder' || rowData['INCOME STATEMENT'] === 'WIP-Costs in Excess of Billings' || rowData['INCOME STATEMENT'] === 'Total Fixed Assets' || rowData['INCOME STATEMENT'] === 'Total Other Assets' || rowData['INCOME STATEMENT'] === 'Total Current Assets' || rowData['INCOME STATEMENT'] === 'Total Current Liabilities' || rowData['INCOME STATEMENT'] === 'Total Long Term Liabilities' || rowData['INCOME STATEMENT'] === 'Total Equity' || rowData['INCOME STATEMENT'] === 'Corp Tax Paid' || rowData['INCOME STATEMENT'] === 'Construction Financing' || rowData['INCOME STATEMENT'] === 'To balance cash' || rowData['INCOME STATEMENT'] === 'Total Other Income') {

            if (typeof value === 'number') {
                return priceBodyTemplatee(value);
            }
            // return value
            return (
                <div style={{  display: 'flex', alignItems: 'center' }}>
                    {value}
                </div>
            );
        }

        if (rowData['INCOME STATEMENT'] === 'Gross Profit') {
            if (value == 'Gross Profit') {
                return value
            }
            let numberValue;
            if (typeof value === 'string') {
                numberValue = parseFloat(value.replace("%", ""));
            } else {
                numberValue = parseFloat(value);
            }

            const formattedValue = `${numberValue.toFixed(2)}`;
            const color = numberValue < 0 ? 'red' : 'black';
            const backgroundColor = numberValue < 0 ? '#fcd9d9' : '';
            const border = numberValue < 0 ? '1px solid red' : '';

            return (
                <div style={{ color, backgroundColor, border }}>{formattedValue}</div>
            );
        }

        if (typeof value === 'number') {
            if (value === 0) {
                return <div style={{ height: '36px', paddingTop: "8px" }}></div>;
            }            
            return priceBodyTemplatee(value);
        }
        return (
            <div style={{  display: 'flex', alignItems: 'center' }}>
                {value}
            </div>
        );
    };

    const openEditModal = (month, year) => {
        setSelectedMonth(month);
        setSelectedYear(year);
        setIsModalOpen(true);
    }

    const headerClick = (data) => {

        var x = data.split(' ');
        // ColumnReComplated[data] == 'Y';
        if (x.length == 2) {
            return (
                <React.Fragment>

                    {data}
                    <Button icon="pi pi-plus " type="button" title='Edit Income Statement' style={{ width: '20px', top: 0, height: '20px', color: ColumnReComplated[data] === 'Y' ? 'white' : '', }} rounded outlined onClick={() => openEditModal(x[0], x[1])} className="ml-2" />

                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                {data}
            </React.Fragment>
        )
    }



    const headerGroup = (
        <ColumnGroup>
            <Row style={{ padding: '8px !important', }}>

                <Column
                    field={ColumnNameKey[0]}
                    header={ColumnName[0]}
                    frozen
                    style={{ fontSize: '16px', minWidth: '340px', textAlign: 'left', borderBottom: '1px solid gray', borderRight: '1px solid gray', padding: '8px !important', height: "38px" }}
                />

                {ColumnNameKey.slice(1).map((row, i) => (
                    <Column
                        key={i + 1}
                        headerStyle={{ background: ColumnReComplated[row] == 'Y' ? "#00D26A" : "", "color": ColumnReComplated[row] == 'Y' ? "white" : '' }}
                        header={headerClick(ColumnName[i + 1])}
                        style={{
                            textAlign: 'center',
                            minWidth: ColumnName[i + 1] === 'Year' ? '250px' : '150px',
                            padding: '8px !important',
                            borderBottom: '1px solid gray',
                            // borderRight: i === 0 ? '1px solid gray' : ColumnName[i + 1] === '% of Sales' ? '1px solid gray' : '',
                            // borderLeft: ColumnName[i + 1] === 'Year' ? '1px solid gray' : ColumnName[i + 1] === '% of Sales' ? '1px solid gray' : '',
                            fontSize: '16px',
                            backgroundColor:
                                i + 1 === 25 || i + 1 === 26 || i + 1 === 27 || i + 1 === 52 || i + 1 === 53 || i + 1 === 54 || i + 1 === 79 || i + 1 === 80 || i + 1 === 81

                                    ? '#eeecec'
                                    : ColumnName[i + 1] === 'Year' || ColumnName[i + 1] === '% of Sales' ? '#eeecec'
                                        : '#ffffff'
                        }}
                    />
                ))}
            </Row>
        </ColumnGroup>
    );

    const toast = useRef(null);

    const closeModelAdd = (w) => {

        if (w === undefined) {
            setIsModalOpen(false);
        } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: w });
            getProjection();
            setIsModalOpen(false);
        }
    }

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(projection);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'products');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };


    // ------------------------------------
    const StartDateAndEndDateSelect = () => {

        const startDate = new Date(selectOnStartDate);

        const endDate = new Date(selectOnEndDate);
        if (startDate > endDate) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start date should be before end date.' });
            return;
        }

        updateDateInBackend(selectOnStartDate, selectOnEndDate);


    }
    const updateDateInBackend = (startDate, endDate) => {
        setIsLoading(true);
        var _body = {
            startDate: startDate,
            endDate: endDate,
        }

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };

        fetch(Api.API_BASE_URL + 'change-startDate-endDate/2', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                getProjection();
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
    }
    // ------------------------------------
    const onRowSelect = (e) => {
        // const rowData = e.data;
        // console.log('rowData ==>>', rowData);
        // alert('Selected Row Data: ' + rowData['INCOME STATEMENT']);
        console.log('Selected Row:', e.data); // Log the selected row data
        setSelectedProduct(e.data);

    };


    return (
        <>
            <Toast ref={toast} />

            <div className="dataTableProjection p-2" >
                <div className="flex justify-content-between p-0">
                    <div className=" p-0">
                        <button type="button" title='Download Income Statement in xlxs formate' style={{ cursor: 'pointer' }} onClick={exportExcel} data-pr-tooltip="XLS" outlined className="exce-download-button m-2" >
                            <div className='flex items-center  gap-2 py-1'>
                                <FaFileExcel size={14} />
                                <span > Download Excel </span>
                            </div>
                        </button>
                    </div>

                    <div className='flex gap-4 items-center' style={{ alignItems: 'center' }} >
                        <div>
                            <label style={{ fontWeight: '400', marginRight: '5px' }}>Start Date</label>
                            <InputText type="date" style={{ height: '34px', borderRadius: '3px', border: '1px solid #80808B', padding: '10px' }} value={selectOnStartDate} onChange={(e) => setSelectOnStartDate(e.target.value)} />

                        </div>
                        <div>
                            <label style={{ fontWeight: '400', marginRight: '5px' }}>End Date</label>
                            <InputText type="date" style={{ height: '34px', borderRadius: '3px', border: '1px solid #80808B', padding: '10px' }} value={selectOnEndDate} onChange={(e) => setSelectOnEndDate(e.target.value)} />

                        </div>

                        <div>
                            <button type="button" title='Save the Date' style={{ cursor: 'pointer' }} onClick={StartDateAndEndDateSelect} className="customSave-button m-2" >
                                <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center' }}>
                                    <FaSave size={16} />
                                    <span> SAVE </span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

                <div  >
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable
                            value={projection}
                            headerColumnGroup={headerGroup}
                            className="sticky-header-table"
                            scrollable
                            stripedRows
                            rowHover={true}
                            rowClassName={rowClass}
                            selection={selectedProduct}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            dataKey="INCOME STATEMENT"
                            selectionMode="single"
                            showGridlines
                            scrollHeight="79vh"
                            style={{ minWidth: '50rem', overflowX: 'auto' }}
                            tableStyle={{ tableLayout: 'fixed', width: 'auto', borderCollapse: 'separate', borderSpacing: '0', }}
                        >
                            {ColumnNameKey.map((row, i) => (
                                <Column
                                    key={i}
                                    field={row}
                                    rowSpan={1}
                                    body={renderDecimalCell}
                                    className='no-padding'
                                    style={{
                                        minHeight: '36px',
                                       
                                        textAlign: i === 0 ? 'left' : 'center', 
                                        minWidth: i === 0 ? '320px' : '150px',
                                        padding: '8px',
                                        fontWeight: ColumnName[i] === 'Year' || ColumnName[i] === '% of Sales' ? '600' : '400',
                                        fontSize: '14px',

                                        backgroundColor: i === 0 ? 'white' : (i + 1 === 26 || i + 1 === 27 || i + 1 === 28 || i + 1 === 53 || i + 1 === 54 || i + 1 === 55 || i + 1 === 80 || i + 1 === 81 || i + 1 === 82 ? '#B7B7B7' : ColumnName[i] === 'Year' || ColumnName[i] === '% of Sales' || ColumnName[i] === 'Q1' || ColumnName[i] === 'Q2' || ColumnName[i] === 'Q3' || ColumnName[i] === 'Q4' ? '#f2f0f0' : 'transparent')
                                    }}
                                    bodyClassName={(rowData) =>
                                        rowData['INCOME STATEMENT'] === ""
                                            ? "blank-row"
                                            : rowData['INCOME STATEMENT'] === "Total" ||
                                                rowData['INCOME STATEMENT'] === "Net Profit" ||
                                                rowData['INCOME STATEMENT'] === "Cash - end" ||
                                                rowData['INCOME STATEMENT'] === "COGS" ||
                                                rowData['INCOME STATEMENT'] === "Gross Profit 8" ||
                                                rowData['INCOME STATEMENT'] === "Expenses" ||
                                                rowData['INCOME STATEMENT'] === "Total Expenses" ||
                                                rowData['INCOME STATEMENT'] === "Net Profit" ||
                                                rowData['INCOME STATEMENT'] === "Sub total" ||
                                                rowData['INCOME STATEMENT'] === "Balance Sheet" ||
                                                rowData['INCOME STATEMENT'] === "Projections And Assumptions" ||
                                                rowData['INCOME STATEMENT'] === "Gross Profit" ||
                                                rowData['INCOME STATEMENT'] === "NAHB Ratios"
                                                ? "net-profit-bg-text"
                                                : "archive-table-text"
                                    }
                                    frozen={i === 0}
                                />
                            ))}
                        </DataTable>
                    )}
                </div>
                {/* -----------------------------------*/}
                {isModalOpen && <ProjectionAddModel visible={isModalOpen} projection={[]} closeModel={(e) => closeModelAdd(e)} setMonth={selectedMonth} setYear={selectedYear} />}
                {/* -------------------Projection Setting--------------*/}
                {isProjectionSetting && <ProjectionSettingViewModal getData={isProjectionSetting} closeModel={() => setIsProjectionSetting(false)} />}

            </div>
        </>
    )
}

export default Projection

